import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProjectCard.css";
import Tag from "./Tag.jsx";

const ProjectCard = ({ project }) => {
    const navigate = useNavigate();
    
    const handleClick = () => {
        navigate(`/project/${project.slug}`);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    };

    return (
        <div className="card-container" onClick={handleClick} style={{ cursor: "pointer" }}>
            <div className="card-preview">
                <img className="card-image" src={project.cover} alt={"image of " + project.title}/>
            </div>
            <div className="card-info">
                <h2>{project.title}</h2>
                {project.tags && (
                    <div className="card-tags">
                        {project.tags.map((tagName) => {
                            return (
                                <Tag key={tagName} icon={`/tags/${tagName}.png`} name={tagName} />
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProjectCard;